// main.ts
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { startSession, updateToken, logout } from './auth/services/SessionService';
import storeConstants from './utils/constants/StoreConstants';
import { setSplashStep, dismissSplash } from './utils/services/SplashScreenService';
import { initTheme } from './utils/services/ThemeService';

import './registerServiceWorker';
import './auth/interceptors/registerAuthInterceptor';

// BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

initTheme();

;(async () => {
  const MAX_SESSION_TIME = 2 * 60 * 60 * 1000; // 2h
  const UPDATE_SESSION_TIME = 30 * 60 * 1000; // 30min

  try {
    setSplashStep(0);
    await startSession();
    await updateToken(MAX_SESSION_TIME);
    setSplashStep(1);
    await store.dispatch(storeConstants.actions.GET_AUTHENTICATED_USER);
    setSplashStep(2);
    await store.dispatch(storeConstants.actions.GET_SUBSCRIBER_LIST);
    setSplashStep(3);
    await Promise.all([
      store.dispatch(storeConstants.actions.GET_AUTHENTICATED_USER_ROLES),
      store.dispatch(storeConstants.actions.GET_STORE_LIST),
    ]);

    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);

    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');

    // o app ja renderizou por baixo do splash, entao a saida revela a tela pronta
    await Vue.nextTick();
    dismissSplash();

    setInterval(async () => {
      await updateToken(UPDATE_SESSION_TIME);
    }, UPDATE_SESSION_TIME);

    window.onfocus = () => {
      updateToken(UPDATE_SESSION_TIME);
    };
  } catch (err: any) {
    if (err?.status > 400) {
      let msg = `${err.message}`;

      if (!!err.errorCode) {
        msg += `\n\nCódigo do erro: ${err.errorCode}`;
      }

      alert(msg);
      return await logout();
    }
  }
})();
